app.directive('aboutRpr', ['portalHelper', function (portalHelper) {
  return {
    scope: {},
    templateUrl: portalHelper.getUrlRev('html_templates/directives/about_rpr.dce1f082.html'),
    controller: function ($scope) {
      // Values from VENDOR_ENV and APP_ENV globals
      $scope.environment = window.VENDOR_ENV.sentry.environment;
      $scope.ui_version = window.APP_ENV.build.uiVersion;
      $scope.ui_build = window.APP_ENV.build.uiBuild;
      $scope.api_version = window.APP_ENV.build.apiVersion;
      $scope.api_build = window.APP_ENV.build.apiBuild;
      $scope.deploy_datetime = window.APP_ENV.build.deployDatetime;
    }
  };
}]);
